import _ from "lodash";

export const convertLocationsEntitiesToPlural = (name: string) => {
  switch (name) {
    case "country":
      return "countries";
    case "city":
      return "cities";
    default:
      return "";
  }
};

export const convertLocationValueToObject = (value: any) => {
  switch (value.type) {
    case "country":
      return value.key;
    case "city":
      return { key: value.key, radius: 17, distance_unit: "kilometer" };
    default:
      return {};
  }
};

export const calculateTotalsForGender = (results, gender) =>
  _.reduce(results, (sum, ageRange) => sum + ageRange[gender], 0);

export const urlToImage = (url, callback) => {
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function() {
    var canvas = document.createElement('CANVAS');
    var ctx = canvas.getContext('2d');
    var dataURL;
    canvas.height = this.height;
    canvas.width = this.width;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL("image/png");
    callback(dataURL);
    canvas = null;
  };
  img.src = 'https://cors-anywhere.herokuapp.com/'+url;
};

export const formatNumber = (number, separator) => {
  if(number > 0){
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator || " ");
  } else {
    return "inadequate data";
  }

}



// WEBPACK FOOTER //
// ./src/lib/utils.js